import { base } from "../../constants/base";
import { countRating } from "../../constants/base";

const PopularProfessionalCard = ({ professional }) => {

  console.log(professional, "professionals");


  return (
    <div className="popular-professional-card">
      <div className="popular-card-image">
        {professional.images.map((image) =>
          image.type === "profile" || image.type === "logo" ? (
            <img src={base.imageUrl + image?.path} alt="" />
          ) : (
            ""
          )
        )}
        <span className="rating-star">
          <i className="fa-solid fa-star"></i>
          {professional?.requests && countRating(professional?.requests)}
        </span>
      </div>

      <div className="popular-card-text">
        <h1>{professional?.name}</h1>
        <h3>{professional?.role?.name}</h3>
        <p>{professional?.total_services_done} Services</p>
      </div>
    </div>
  );
};

export default PopularProfessionalCard;
